import {FIXED_COLUMNS, NOT_CONFIGURABLE_COLUMNS} from './constants'

export const isSortByColumnUnavailable = (sortBy, selectedMap) => !NOT_CONFIGURABLE_COLUMNS.includes(sortBy.by) && !selectedMap[sortBy.by]

export const isColumnFixed = (column) => FIXED_COLUMNS.includes(column)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/utils.js